module.exports = __webpack_public_path__ + "media/recipes/65-f7e00982.png";